import React from "react";


export const NewsBanner: React.FC = () => {
  return (
    <section className="w-full">
      <div className="news-banner-gradient bg-primary-50 mx-auto py-3.5 text-center">
        <div className="section-inset">
          <p className="text-primary-500 body-b-semibold">
            LATEST NEWS: Balance embeds Bravo AI in mobile app, making it
            available to 200+ credit unions, EAPs and employers.
          </p>
        </div>
      </div>
    </section>
  );
};
